<app-admin-dashboard>
  <div class="card">
    <div class="mb-3"></div>

    <div class="header-card separator pt-0">
      <div class="w-3 container-title">
        <span class="text-xl font-medium text-800">
          {{'AdminDownloadedDocuments.PageTitle' | translate}}
        </span>
      </div>
      <div class="w-9 flex align-items-center justify-content-end flex-wrap gap-2">
        <p-button
          label="{{'AdminDownloadedDocuments.ReportButton' | translate}}"
          icon="pi pi-download"
          (click)="goToReport()">
        </p-button>
      </div>
    </div>

    <div class="body-card" style="margin-top: 1rem;">
      <app-downloaded-documents-table
        [modalMode]="false">
      </app-downloaded-documents-table>
    </div>
  </div>
</app-admin-dashboard>
